export default "__VITE_ASSET__CF3j$bJo__"